import { $T } from 'client/library/translation'
import type { FrameMenuItem } from 'app/types'
import type { ServiceInitArgs } from 'app/services/base'
import { useWorkspaceStore } from 'app/services/pinia/workspace-store'

export function buildNoteMenu(services: ServiceInitArgs, options?: { isHideDisplayNote?: boolean }) {
  const { action } = services
  if (!action) {
    return []
  }

  const workbook = useWorkspaceStore().workbook
  if (!workbook) return []

  const menus: FrameMenuItem[] = [
    {
      label: $T('Edit'),
      enable: action.ui.openNotePopover.isEnabled,
      action: () => action.ui.openNotePopover.execute({ status: true }),
    },
    {
      type: 'separator',
    },
    {
      label: $T('Delete'),
      enable: workbook.getAction('editor.removeNote').isEnabled,
      action: () => workbook.getAction('editor.removeNote').execute(),
    },
    {
      type: 'separator',
    },
    {
      label: options?.isHideDisplayNote ? $T('Hide') : $T('Display'),
      enable: true,
      action: () =>
        options?.isHideDisplayNote
          ? workbook.getAction('editor.hideDisplayTopicNotes').execute()
          : workbook.getAction('editor.showDisplayTopicNotes').execute(),
    },
  ]
  return menus
}
